import type { ReactNode } from 'react'

import { Trans } from '@lingui/react'

import { Typography } from '@twisto/components/atoms/typography'
import { AnswerIcon } from '@twisto/icons'

import * as styles from './short-answer.styles'

type Props = {
  children: ReactNode
}
export const ShortAnswer = ({ children }: Props) => (
  <div css={styles.container}>
    <div>
      <Typography
        component="h2"
        css={styles.headline}
        fontWeight="medium"
        variant="b2"
      >
        <AnswerIcon css={styles.icon} height="1em" width="1em" />
        <Trans id="article.shortAnswer.title" />
      </Typography>
    </div>
    <Typography variant="b2">{children}</Typography>
  </div>
)
